import { render, staticRenderFns } from "./MyMediaItems.vue?vue&type=template&id=70f7c852&scoped=true&"
import script from "./MyMediaItems.vue?vue&type=script&lang=js&"
export * from "./MyMediaItems.vue?vue&type=script&lang=js&"
import style0 from "./MyMediaItems.vue?vue&type=style&index=0&id=70f7c852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f7c852",
  null
  
)

export default component.exports